import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { bookTarget, propertyCopy } from "@/lib/clientTypes";
import { Page, PageHeader, Loading } from "@/components/calm/Calm";

// "Book" for signed-in property accounts. Sends them to in-app checkout on
// their property (portfolio discount applied there), or to the www form when
// they have no property yet.
export default function DeveloperBookPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const kind = user?.account_type;
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    api.get("/dev/projects")
      .then((r) => r.data || [])
      .catch(() => null)
      .then((list) => {
        if (!live) return;
        if (list === null) { setFailed(true); return; }
        const t = bookTarget(kind, list);
        if (t.external) window.location.replace(t.href);
        else navigate(t.href, { replace: true });
      });
    return () => { live = false; };
  }, [kind, navigate]);

  const copy = propertyCopy(kind);
  if (!failed) return <Page testid="developer-book"><Loading /></Page>;
  return (
    <Page testid="developer-book">
      <PageHeader title={copy.book.label} />
      <div role="alert" style={{ fontSize: 14 }}>
        {`Couldn’t load your ${copy.things.toLowerCase()}. `}
        <a href={copy.book.www || copy.book.href}>Book on brxs.ca instead</a>.
      </div>
    </Page>
  );
}
